<template>
  <div id="update">
    <Metadata
      :title="this.title"
    />
    <div id="logo-purple" />
    <form>
      <input
        type="password"
        placeholder="Current Password"
        name="password-current"
        v-model="input.passwordCurrent"
      />
      <input
        type="password"
        placeholder="New Password"
        name="password-new"
        v-model="input.passwordNew"
      />
      <input
        type="password"
        placeholder="New Password (confirm)"
        name="password-confirm"
        v-model="input.passwordConfirm"
      />
      <button type="button" v-on:click="update()">update Password</button>
    </form>
    <Bottom />
  </div>
</template>

<script>

import Top from '../../components/nav/Top.vue';
import Bottom from '../../components/nav/Bottom.vue';

export default {
  name: 'update',
  beforeMount() {
    if (!this.$store.getters.hasUser) {
      this.$router.replace('/login');
    }
  },
  components: {
    Top,
    Bottom,
  },
  data() {
    return {
      title: `reporting - update`,
      input: {
        username: this.$store.state.user,
        passwordCurrent: '',
        passwordNew: '',
        passwordConfirm: '',
      },
    };
  },
  methods: {
    update() {
      this.$http.post('/api/users/update', this.input)
        .then(() => {
          this.$router.push({ name: 'loginThanks', params: { from: 'update' } });
        })
        .catch(() => {
          this.input.passwordCurrent = '';
          this.input.passwordNew = '';
          this.input.passwordConfirm = '';
        });
    },
  },
};
</script>

<style>
#logo-purple {
  background-image: url('~@/assets/logo/purple.png');
  background-size: 100% auto;
  background-position: center;
  margin: 10% auto 0 auto;
  width: 78px;
  height: 78px;
}

form {
  width: 240px;
  height: 32px;
  margin: 54px auto 0px auto;
  text-align: center;
  top: 20%;
  left: 40%;
}

form input {
  background: #ffffff;
  width: 100%;
  border: 1px solid #cccccc;
  margin: 0 0 15px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 5px;
}

form button {
  text-transform: uppercase;
  margin: 5px auto 11px auto;
  background: #4c123e;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #FFFFFF;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  border-radius: 5px;
}
</style>
